import React, { FC } from 'react'
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import { PharmacyListResponse } from '@/features/auth/types/pharmacy'

interface PharmacySelectorProps {
  value: string
  onChange: (value: string) => void
  pharmacyData: PharmacyListResponse | null
  disabled?: boolean
  fullWidth?: boolean
  size?: 'small' | 'medium'
  label?: string
  showAllOption?: boolean // 全社オプションの表示制御
}

export const PharmacySelector: FC<PharmacySelectorProps> = ({
  value,
  onChange,
  pharmacyData,
  disabled = false,
  fullWidth = true,
  size = 'medium',
  label = '表示薬局',
  showAllOption = false, // デフォルトは非表示（明示的に指定が必要）
}) => {
  return (
    <FormControl fullWidth={fullWidth} size={size}>
      <InputLabel id="pharmacy-select-label" shrink>
        {label}
      </InputLabel>
      <Select
        labelId="pharmacy-select-label"
        value={value}
        label={label}
        onChange={(e) => onChange(e.target.value)}
        displayEmpty
        notched
        disabled={disabled || !pharmacyData?.has_headquarters_permission}
        renderValue={(value) => {
          if (value === '' && showAllOption) return '全社'
          const pharmacy = pharmacyData?.pharmacies.find((p) => p.id === value)
          return pharmacy ? pharmacy.name : ''
        }}
      >
        {showAllOption && pharmacyData?.has_headquarters_permission && (
          <MenuItem value="">全社</MenuItem>
        )}
        {pharmacyData?.pharmacies.map((pharmacy) => (
          <MenuItem key={pharmacy.id} value={pharmacy.id}>
            {pharmacy.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
